<template>
    <v-card class="mx-auto" outlined :dark="isDark" :min-width="cardMinWidth" :max-width="cardMaxWidth"
        :min-height="cardMinHeight" :color="cardColor" elevation="4" :tile="true">
        <v-container>
            <v-row >
                <v-col v-if="cardShowTitle">
                    <slot name="crdTitle">
                        <v-list-item-title class="text-h5 mb-4 tertiary--text text-center">
                            {{ cardTitle }}
                        </v-list-item-title>
                    </slot>
                    <v-divider></v-divider>
                </v-col>
                <v-col v-if="cardShowSubHeader">
                    <slot name="crdSubHeader">
                        <!-- connected to props so you can change it -->
                        <div class="text-overline mb-4 tertiary--text">
                            {{ cardSubHeaderText }}
                        </div>
                    </slot>
                </v-col>
            </v-row>
            <slot :name="cardAutomatic" v-if="!cardShowAutomatic">
                <!-- <v-row justify="center" no-gutters>
                    <v-col cols="6" xs="0" sm="0" md="6" class="flex-grow-0 flex-shrink-0">
                        <v-row no-gutters justify="center">
                            <br>
                            <h1 class="text-h6 font-weight-bold mb-3">
                                {{ username }}
                            </h1>
                            <v-divider></v-divider>
                        </v-row>
                    </v-col>
                </v-row> -->
                <br>
                <v-row justify="center" no-gutters>
                    <!-- <v-col cols="3" xs="0" sm="0" md="3" class="flex-grow-0 flex-shrink-0">
                    </v-col> -->
                    <v-col cols="6" xs="0" sm="0" md="6" class="flex-grow-0 flex-shrink-0">
                        <v-row no-gutters justify="center">
                            <br>
                            <h3> {{ estado }} </h3>
                            <p class="subheading font-weight-regular">
                                <br>Suscripciones activas: {{ suscripcionesActivas }}
                                <br>Bots creados: {{ botsCreated }}
                                <br>Fin suscripción: {{ endSubs }}
                            </p>
                        </v-row>
                    </v-col>
                </v-row>

            </slot>

            <!-- Inner card area where yuou can put tables/tabs or anything -->
            <slot :name="cardInner" v-if="cardShowInner">
                <!-- <MaterialfyDataChart ref="dataChart" /> -->
                <!-- <v-card-text class="text-h5 font-weight-bold">
                    This is a bunch of text since i couldnt think of anything to fill
                    up the default content of this card. fix with pull request lol
                </v-card-text> -->
            </slot>

            <v-card-actions>
                <slot :name="cardActions" v-if="cardShowActions"> </slot>
            </v-card-actions>
        </v-container>
    </v-card>
</template>

<script>
import UserService from '@/services/user.service'
import User from '../../models/user'


export default {
    name: 'MaterialfyDataHome',
    props: {
        cardMinHeight: {
            default: '100',
        },
        cardMinWidth: {
            default: '300',
        },
        cardMaxWidth: {
            default: '600',
        },
        cardTitle: {
            type: String,
            default: null
        },
        cardSubHeaderText: {
            default: 'Subheader',
        },
        cardIcon: {
            default: 'crdIcon',
        },
        cardInner: {
            default: 'crdInner',
        },
        cardActions: {
            default: 'crdActions',
        },
        cardHeaderColor: {
            default: 'tertiary',
        },
        cardColor: {
            default: 'primary',
        },
        cardAvatar: {
            default: 'crdAvatar',
        },
        cardAutomatic: {
            default: 'crdAutomatic',
        },
        isDark: {
            default: false,
        },
        cardShowDivider: {
            default: true,
        },
        cardShowActions: {
            default: true,
        },
        cardShowInner: {
            default: true,
        },
        cardShowAvatar: {
            default: true,
        },
        cardShowTitle: {
            default: true,
        },
        cardShowSubHeader: {
            default: true,
        },
        cardShowAutomatic: {
            default: true,
        },
        data: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            title: 'HOME',
            user: new User('', '', ''),
            estado: '',
            suscripcionesActivas: '',
            content: '',
            username: '',
            botsCreated: '',
            endSubs: '',
            totalInvertido: '',
            chartBeneficios: '',
            totalComisiones: '',
            totalBeneficios: '',
            message: '',
        }
    },
    beforeDestroy() {
    },
    mounted() {
        this.loaded = false
        UserService.getHomeInfo().then(
            response => {
                // console.log(response)
                if (response.data.activado) {
                    this.estado = 'ACTIVADO'
                } else {
                    this.estado = 'NO ACTIVADO'
                }
                this.username = response.data.userName
                this.suscripcionesActivas = response.data.suscripcionesActivas
                this.botsCreated = response.data.botsCreated
                this.endSubs = response.data.end_time
                this.totalInvertido = response.data.totalInvertido

            },
            error => {
                this.content =
                    (error.response && error.response.data && error.response.data.message) ||
                    error.message ||
                    error.toString();
                if (error.response && error.response.status === 403 || error.response.status === 401) {
                    this.$store
                        .dispatch('logout', this.user) //calls the login action and passes login info
                        .then(() => this.$router.push('/')) //redirect to dash after login
                        .catch((err) => {
                            console.log(err)
                            this.snackbar = true //shows error on wrong pass
                        })
                }
            }
        );
    },
    methods: {

    }
}
</script>

<style scoped>
.v-progress-circular {
    margin: 1rem;
}

.innercardheight {
    height: 100px;
}
</style>
